import { render, staticRenderFns } from "./ElVideoPopup.vue?vue&type=template&id=5bf1fcca"
import script from "./ElVideoPopup.vue?vue&type=script&lang=js"
export * from "./ElVideoPopup.vue?vue&type=script&lang=js"
import style0 from "./ElVideoPopup.vue?vue&type=style&index=0&id=5bf1fcca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports